export default {
  'dashboard.title': 'Dashboard',
  'dashboard.widget.monthly-requests.title': 'Requests of the month',
  'dashboard.widget.most-used-processes.title': 'Most used processes',
  'dashboard.widget.board.title': 'Management board',
  'dashboard.widget.board.requests': `Requests: {value}`,
  'dashboard.widget.board.enabled-processes': 'Processes enabled: {value}',
  'dashboard.widget.board.active-users': 'Active users: {value}',
  'dashboard.widget.board.total': 'Total: {value}',
  'dashboard.widget.board.planTotal': 'Total plan: {value}',
  'dashboard.widget.storage.title': 'Usage',
  'dashboard.widget.storage.used-space': 'Storage / Used space',
  'dashboard.widget.storage.emails-sent': 'Sent E-Mails',
  'dashboard.widget.storage.entities': 'Entities',
  'dashboard.widget.storage.generated-documents': 'Generated Documents',
  'dashboard.widget.total-monthly-requests.title': 'Total requests per month',
  'dashboard.widget.pending-tasks.title': 'Pending tasks',
  'dashboard.widget.partners.title': 'Top contributors',
  'dashboard.widget.last-requests.title': 'Last requests sent',
  'dashboard.widget.tasks.pending': 'Pending',
  'dashboard.widget.tasks.approved': 'Approved',
  'dashboard.widget.tasks.rejected': 'Rejected',
  'dashboard.widget.tasks.canceled': 'Canceled',
  'dashboard.widget.partners.requests': '{requests} requests',
  'dashboard.widget.ai-consumptions.title': 'AI Consumptions',
  'dashboard.widget.ai-consumptions.provider': 'Provider',
  'dashboard.widget.ai-consumptions.model': 'Model',
  'dashboard.widget.ai-consumptions.family': 'Family',
  'dashboard.widget.ai-consumptions.input-tokens': 'Input Tokens',
  'dashboard.widget.ai-consumptions.output-tokens': 'Output Tokens',
  'dashboard.widget.ai-consumptions.cached-tokens': 'Cached Tokens',
  'dashboard.widget.ai-consumptions.total-tokens': 'Total Tokens',
  'dashboard.widget.ai-consumptions.total-consumption': 'Total Consumption',
  'dashboard.widget.ai-consumptions.price': 'Price',
  'dashboard.widget.ai-consumptions.no-data': 'No AI consumption data to display',
};
